var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:_vm._f("statusFilter")(_vm.props),attrs:{"title":_vm.props.data && _vm.props.data.value}},[_vm._v(" "+_vm._s(_vm.props.data && _vm.props.data.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }